export default [{
  path: '/anecdote',
  name: 'anecdote',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/anecdote/index')
}]
